import React, { useEffect } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

interface ReCaptchaV3Props {
  setRecaptchaToken: (recaptchaToken: string) => void;
  recaptchaToken: string;
}

export function ReCaptchaV3({
  setRecaptchaToken,
  recaptchaToken
}: ReCaptchaV3Props) {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleReCaptchaVerify = async () => {
    if (executeRecaptcha) {
      const recaptchaToken = await executeRecaptcha('signup');
      setRecaptchaToken(recaptchaToken);
    }
  };

  useEffect(() => {
    if (!recaptchaToken) {
      handleReCaptchaVerify();
    }
  }, [handleReCaptchaVerify, recaptchaToken]);

  return <></>;
}
